/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_AbandoningInputs */



/**
* | output |
* | --- |
* | "Abandoning..." |
*
* @param {Profile_AbandoningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_abandoning = /** @type {((inputs?: Profile_AbandoningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_AbandoningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abandon...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abandonando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Abandonando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbandono...")
	return /** @type {LocalizedString} */ ("Abandoning...")
});